import React, { useState, useEffect } from 'react';
import { useHttp } from '../../hooks/httpHook';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import VacancyCard from '../../components/VacancyCard';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { connect, useSelector } from 'react-redux';
import { Box } from '@material-ui/core';
import Nirvana from '../../assets/nirvanaMob.PNG';
import Collapse from '@material-ui/core/Collapse';
import Button from '@material-ui/core/Button';
import { isMobile } from "react-device-detect";
import { total } from '../../redux/actions/clsActions';
import { vacancies, } from '../../redux/actions/filterActions';

const useStyles = makeStyles((theme) => ({
    header: {
        paddingLeft: 20,
        paddingTop: 25,
        fontSize: 20,
        color: '#fff'
    },
    nirvana: {
        marginLeft: 67,
        marginTop: 40,
        width: 200,
        height: 171,
    },
    placeholder: {
        marginLeft: 27,
        marginTop: 40,
        minWidth: 281,
        minHeight: 48,
        fontSize: 14,
        fontWeight: 400,
    },
    nirvanaPaper: {
        minHeight: 335,
        maxHeight: 335,
        minWidth: 339,
        maxWidth: 339,
        borderRadius: 20,
        marginLeft: 20,
        marginTop: 24,
    },
    showMoreBtn: {
        backgroundColor: '#ffffff',
        color: '#3C70F1',
        marginLeft: 20,
        marginTop: 38,
        minWidth: 335,
        maxWidth: 335,
        minHeight: 58,
        maxHeight: 58,
        boxShadow: '0px 0px 15px rgba(60, 112, 241, 0.45)',
        borderRadius: 10,
        '&:hover': {
            backgroundColor: '#ffffff'

        },
    }
}));

const SearchResultMob = ({total, vacancies}) => {
    const currentVacancies = useSelector((state) => state.filterReducer.vacancies);
    let [headerText, setHeaderText] = useState('Сейчас на Head.z более 50 000 вакансий от топовых компаний');
    let [page, setPage] = useState(1);
    let [placeHolder, setPlaceHolder] = useState('Попробуйте изменить или уточнить запрос. Например: город, должность или стек');
    const currentTotal = useSelector((state) => state.clsReducer.total);
    const classes = useStyles();
    const searched = useSelector((state) => state.clsReducer.searched);
    const currentFilter = useSelector((state) => state.filterReducer);
    const { request } = useHttp();

    const showMore = async () => {
        let pagesAmount = getPagesAmount(currentTotal);
        setPage(page + 1);
        if (page >= pagesAmount) {
            setPage(1);
        }

        currentFilter.vacancies = [];
        request.params = currentFilter;
        request.params.page = page;
        const response = await request(
            `/filter/filtered`,
            'get',
            currentFilter
        );

        if (response && !response.error) {
            total(response.total);
            return vacancies(response.vacancies);
        }
    };

    const getPagesAmount = (totalAmount) => {
        if (!searched || totalAmount <= 8) {
            return 1;
        }
        if (totalAmount % 8 > 0) {
            return Math.floor(totalAmount / 8) + 1;
        }

        return Math.floor(totalAmount / 8);
    };

    useEffect(() => {
        if(searched){

            setHeaderText(`Head.z нашел ${currentTotal?currentTotal:0} вакансий по вашему запросу`);
        }
    }, [currentVacancies.length]);

    useEffect(() => {
        setHeaderText(`Сейчас на Head.z более 50 000 вакансий от топовых компаний`);
    }, []);

    return (
        <Box style={{
            backgroundColor: searched ? '#E3EFFE' : '#3C70F1',
            marginTop: 40,
            paddingBottom: 40,
        }}>
            <Box className={classes.header}>
                <Typography variant="h4" gutterBottom >
                    <b>{headerText}</b>
                </Typography>
            </Box>
            <Box>
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    height="100%"

                >
                    {currentVacancies.map((option, index) => (
                        <VacancyCard key={index} value={option} xs visibility="hidden" />
                    ))}

                </Grid>
                <Collapse in={isMobile && searched && currentVacancies.length}>
                    <Box xs={isMobile ? 12 : 3}>
                        <Button className={classes.showMoreBtn} variant="contained" onClick={() => showMore()} >
                            Показать еще
                        </Button>
                    </Box>
                </Collapse>
            </Box>{
                currentVacancies && currentVacancies.length ?
                    <Box></Box> :
                    <>
                        <Paper className={classes.nirvanaPaper}>
                            <Box className={classes.nirvana}>
                                <img
                                    src={Nirvana}
                                    alt="robot"
                                />
                            </Box>
                            <Box >
                                <Typography align="center" display="block" className={classes.placeholder}>
                                    {placeHolder}
                                </Typography>
                            </Box>
                        </Paper>
                    </>
            }
        </Box>
    );
};

const mapStateToProps = state => ({
    vacancies: state.filterReducer.vacancies,
    total: state.clsReducer.total,
  });
  
  export default connect(mapStateToProps, { vacancies, total })(SearchResultMob)